import { userConstants } from '../../constants';

const initialState = {
  email: null,
  loggedIn: false,
  authChecked: false,
}
export function authentication(state = initialState, action) {
  switch (action.type) {
    case userConstants.LOGIN_REQUEST:
      return {
        ...state,
        loggingIn: true
      };
    case userConstants.LOGIN_SUCCESS:
      return {
        email: action.email,
        loggedIn: true,
        authChecked: true,
        loggingIn: false
      };
    case userConstants.LOGIN_FAILURE:
      return {
        ...state,
        loggedIn: false,
        authChecked: true,
        loggingIn: false
      };
    case userConstants.LOGOUT:
      return {
        email: null,
        loggedIn: false,
        authChecked: true
      };
    case userConstants.REGISTER_SUCCESS:
      return {
        email: action.user.email,
        loggedIn: true,
        authChecked: true
      };
    default:
      return state
  }
}

export const selectLoggingIn = (state) => state.authentication.loggingIn;
export const selectLoggedIn = (state) => state.authentication.loggedIn;
export const selectLoggedInEmail = (state) => state.authentication.email;
export const selectAuthChecked = (state) => state.authentication.authChecked;
